import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { Delivery, DeliveryOrder } from '../../deliveries'
import { useSystemStateHooks } from '../../system'
import { Operation } from '../state/types'

export const useOperationLoaders = () => {
    const systemHooks = useSystemStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadOperation = (
            table: TableName,
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(table, id, dbRequest) as Promise<O<Operation>>
        }

        const loadOperations = async (
            table: TableName,
            ids: string[],
            dbRequest = false
        ) => {
            const { loadByIds } = loaders(companyId)
            const operations = await loadByIds(table, ids, dbRequest) as Operation[]
            return operations.filter(operation => operation.archived !== true)
        }

        const loadDeliveriesOperations = async (deliveries: (DeliveryOrder | Delivery)[]) => {
            let operations: Operation[] = []
            const operationIdsByTable = deliveries.reduce((acc, delivery) => {
                acc[delivery.table] = [...(acc[delivery.table] || []), delivery.operationId]
                return acc
            }, {} as Record<TableName, string[]>)
            for (const table in operationIdsByTable) {
                const loadedOperations = await loadOperations(table as TableName, operationIdsByTable[table as TableName])
                operations = operations.concat(loadedOperations)
            }
            return operations
        }

        return {
            loadOperation,
            loadOperations,
            loadDeliveriesOperations
        }
    }
}
